{
  "id": "campaign-146",
  "name": "Wildflower Meadow",
  "seed": "campaign:146",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "................x...",
    "....h.....T...x.....",
    ".........,..........",
    "......T.,,,.........",
    ".........,..........",
    ".x.........T....Y...",
    "....................",
    "...x................",
    "........x...........",
    ".#...........#....#.",
    ".....#..............",
    "....................",
    "mm......*...........",
    "m......*.*....#...#.",
    ".......T*......,....",
    "..h...........,,,...",
    "...............,....",
    "...............x....",
    "...x.........#.....S"
  ],
  "critters": [
    {
      "kind": "deer",
      "x": 11,
      "y": 9
    },
    {
      "kind": "deer",
      "x": 11,
      "y": 8
    },
    {
      "kind": "deer",
      "x": 15,
      "y": 10
    },
    {
      "kind": "deer",
      "x": 15,
      "y": 9
    },
    {
      "kind": "deer",
      "x": 13,
      "y": 3
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 3,
      "y": 15
    },
    {
      "kind": "gas",
      "x": 5,
      "y": 14
    },
    {
      "kind": "gas",
      "x": 10,
      "y": 0
    },
    {
      "kind": "gas",
      "x": 6,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 14,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 13,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 17,
      "y": 10
    }
  ],
  "hills": [
    {
      "x": 2,
      "y": 3,
      "w": 5,
      "h": 5
    }
  ],
  "generatorVersion": 3,
  "level": 146,
  "biome": "meadow",
  "par": {
    "reel": 13148,
    "push": 11923,
    "selfPropelled": 10440,
    "tractor": 9005,
    "zeroTurn": 7650,
    "fairway": 4377
  },
  "goldTime": {
    "reel": 13073,
    "push": 11664,
    "selfPropelled": 10440,
    "tractor": 8815,
    "zeroTurn": 7650,
    "fairway": 4240
  },
  "routeTries": {
    "par": {
      "reel": 21,
      "push": 0,
      "selfPropelled": 4,
      "tractor": 0,
      "zeroTurn": 0,
      "fairway": 15
    },
    "gold": {
      "reel": 26,
      "push": 38,
      "selfPropelled": 4,
      "tractor": 41,
      "zeroTurn": 0,
      "fairway": 32
    }
  }
}
